import { ReactNode } from "react";
import { Link } from "next-view-transitions";

import joinClassNames from "@/utils/classNames";

type ButtonProps = {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
} & (
  | { href: string; asButton?: never }
  | { href?: never; asButton: true }
);

type ButtonStyleProps = {
  variant?: "primary" | "secondary" | "outline";
  children: ReactNode;
};

const VARIANT_CLASSES = {
  primary: "button--primary",
  secondary: "button--secondary",
  outline: "button--outline",
};

const Button = ({
  children,
  className,
  variant = "outline",
  disabled = false,
  onClick,
  ...props
}: ButtonProps & ButtonStyleProps) => {
  const buttonClasses = joinClassNames(
    "button",
    VARIANT_CLASSES[variant],
    disabled ? "opacity-50 cursor-not-allowed" : "",
    className || ""
  );

  if ('href' in props && props.href) {
    return (
      <Link href={props.href} className={buttonClasses} onClick={onClick}>
        {children}
      </Link>
      
    );
  }

  return (
    <button
      className={buttonClasses}
      disabled={disabled}
      onClick={onClick}
      type={props.type || "button"}
    >
      {children}
    </button>
  );
};

export default Button;
